import { setAnalyticsConsent } from "./analytics";

const KEY = "menstage_privacy_v2";
const MAX_AGE_MS = 180 * 24 * 60 * 60 * 1000;

export function readConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || data.v !== 2 || typeof data.at !== "number") return null;
    if (Date.now() - data.at > MAX_AGE_MS) return null;
    return {
      statistics: data.statistics === true,
      map: data.map === true,
    };
  } catch (error) {
    return null;
  }
}

export function writeConsent(choice) {
  const next = {
    v: 2,
    statistics: choice.statistics === true,
    map: choice.map === true,
    at: Date.now(),
  };
  localStorage.setItem(KEY, JSON.stringify(next));
  setAnalyticsConsent(next.statistics);
  return { statistics: next.statistics, map: next.map };
}

export function applyStoredConsent() {
  const stored = readConsent();
  setAnalyticsConsent(stored ? stored.statistics : false);
  return stored;
}
